/* eslint-disable camelcase */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { closeModal, toggleModal } from "../features/modalSlice";
import useOutsideClick from "../hooks/useOutsideClick"; // Import the hook
import { AppDispatch } from "../app/store";
import toast from "react-hot-toast";
import { renameChat, renameFolder } from "../features/folderSlice";
import { ModalRenameChatProps } from "../types";

const ModalRenameChat: React.FC<ModalRenameChatProps> = ({ folder_id, type, name }) => {
  const dispatch = useDispatch<AppDispatch>();
  const [inputValue, setInputValue] = useState<string>("");
  const modalRef = useRef<HTMLDivElement | null>(null); // Define the type explicitly
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    setInputValue(name);
  }, []);

  const handleRename = async () => {
    try {
      if (inputValue) {
        setLoading(true);
        let message = "";
        if (type === "chat") {
          message = await dispatch(renameChat({ folder_id, name: inputValue })).unwrap();
          dispatch(toggleModal());
        } else if (type === "folder") {
          message = await dispatch(renameFolder({ folder_id, name: inputValue })).unwrap();
          dispatch(toggleModal());
        }

        toast.success(message, {
          className: "md:!bg-[#00B21B]/20 !bg-[#00B21B]/100 dark:!text-white dark:text-[#191919] !shadow-none",
          duration: 2000,
        });
        setLoading(false);
      }
      dispatch(closeModal("ModalRenameChat"));
      setLoading(false);
    } catch (err) {
      toast.error("error occured", {
        className: "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
        duration: 2000,
      });
    }
    setLoading(false);
  };
  // Close modal on outside click
  useOutsideClick({
    modalRef,
    closeAction: () => dispatch(closeModal("ModalRenameChat")),
  });

  return (
    <div className="relative">
      <div className="fixed md:backdrop-blur-[auto] backdrop-blur-10 inset-0 flex justify-center items-center z-50">
        <div className="border-[#5F829F]/50 md:border-0 border-[0.2px] custom-modal-bg rounded-3xl w-[572px] h-[132px] relative md:mx-auto mx-2 md:bg-none md:bg-transparent dark:bg-chatDarkBg/60 bg-lightBg/60" ref={modalRef}>
          {/* Modal Content */}

          <h2 className="text-base px-6 pt-4 pb-1 text-black dark:text-white font-ProximaLight">
            Rename {type}
          </h2>
          <div className="flex  px-6 py-3">
            <input
              type="text"
              value={inputValue} // Bind state to input
              onChange={(e) => setInputValue(e.target.value)} // Update state on change
              className="bg-transparent  rounded-x-lg rounded-l-lg border-[#5f829f73] border-[0.2px]  focus:outline-none h-[43px] w-full px-6 py-3 dark:text-white  "
              placeholder="Folder name"
            />
            <button
              onClick={() => handleRename()}
              className="dark:bg-[#0b2335] bg-[#f0f0f0] backdrop-blur-[42px] bg-opacity-100  rounded-x-lg rounded-r-lg border-[#5f829f73] border-r-[0.2px] border-y-[0.2px] text-black dark:text-white text-sm font-ProximaLight h-[43px] w-[71px]"
            >
              {loading ? "Loading" : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalRenameChat;
